import React, { useContext } from "react";
import PropType from "prop-types";
import "./SlateDisplay.css";
import { GreenMachineContext } from "../GreenMachineContext";

export default function SlateDisplay(props) {
  const { currentStage, STAGE_NUMBERS } = useContext(GreenMachineContext);

  if (currentStage > STAGE_NUMBERS.selectSlate) {
    return null;
  }

  return (
    <div id="gm-sport-selection">
      <ul className="gm-sport-list">
        {props.slates.map((slate) => {
          return (
            <li
              className="gm-slate-option"
              key={slate.id}
              onClick={(e) => props.onClick(e, slate)}
              onKeyPress={(e) => props.onClick(e, slate)}
              role="menuitem"
            >
              <div>
                <p>{slate.prettyStartTime}</p>
                <p>
                  {slate.slatecompetitionSet.edges.length > 1
                    ? slate.slatecompetitionSet.edges.length +
                      " Games " +
                      slate.suffix
                    : slate.slatecompetitionSet.edges[0].node.competition.name +
                      " " +
                      slate.suffix}
                </p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

SlateDisplay.propTypes = {
  slates: PropType.arrayOf(PropType.object).isRequired,
  onClick: PropType.func.isRequired,
};
